export default __webpack_public_path__ + "static/media/ZillaSlab-Regular.77d29d36.ttf";